import { ensureSandboxDemoPatients } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';

import { createLotusRequestConfig } from '@/shared/api/lotus';

import type { DemoRoster } from './demoRoster.js';

export async function ensureDemoPatients(): Promise<DemoRoster> {
  const config = await createLotusRequestConfig();
  const response = await ensureSandboxDemoPatients(config);
  return lotusHealthZod.ensureSandboxDemoPatientsResponse.parse(response.data).roster;
}
